import { render } from "./FormTagBeneficiarios.vue?vue&type=template&id=002c9d83"
import script from "./FormTagBeneficiarios.vue?vue&type=script&lang=js"
export * from "./FormTagBeneficiarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__